module.exports = __webpack_public_path__ + "img/快乐.8a38094e.png";